import { useCallback, useState } from "react";
import { getAuditPerforms } from "../../../services/apis/auditApis";

const useAuditPerforms = () => {
  const [performs, setPerforms] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [pageTrack, setPageTrack] = useState({ currPage: 1, totalPages: 1 });

  const fetchPerforms = useCallback(async (page, limit, activeFilters = {}) => {
    setLoading(true);
    try {
      const response = await getAuditPerforms({ page, limit, ...activeFilters });
      const data = response?.data;
      setPerforms(data?.performs || []);
      setTotal(data?.total || 0);
      setPageTrack({
        currPage: data?.page || page,
        // backend returns total, not total_pages
        totalPages: Math.max(1, Math.ceil((data?.total || 0) / (data?.limit || limit || 50)))
      });
    } catch (error) {
      console.error("Failed to fetch audit performs:", error);
      setPerforms([]);
      setTotal(0);
      setPageTrack({ currPage: 1, totalPages: 1 });
    } finally {
      setLoading(false);
    }
  }, []);

  return { performs, total, loading, pageTrack, fetchPerforms };
};

export default useAuditPerforms;
